import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  flex: 1;
  width: 100%;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.1, theme.colors.background)};
  overflow: hidden;
`;

export const Header = styled.div`
  width: 100%;
  height: 35px;
  display: flex;
  align-items: center;
  gap: 50px;
  padding: 5px;
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
`;

export const Titulo = styled.h4`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textBackground};
`;

export const ListaTurma = styled.ul`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.metrics.radius};
`;

export const Turma = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  background-color: ${({ theme }) => theme.colors.background};

  &:not(:last-child) {
    margin-bottom: 5px;
  }
`;

export const NomeTurma = styled.span`
  width: 90px;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textBackground};
`;
